"use client";

import { cn } from "../../lib/utils";

export type PostStudioActivationBannerProps = {
  label: string;
  onDismiss: () => void;
  className?: string;
};

export function PostStudioActivationBanner({
  label,
  onDismiss,
  className,
}: PostStudioActivationBannerProps) {
  return (
    <button
      type="button"
      onClick={onDismiss}
      className={cn(
        "sticky top-3 z-30 flex w-full items-center justify-center rounded-xl bg-[#10B981] px-4 py-3 text-center text-[13px] font-semibold text-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.18)]",
        className
      )}
    >
      <span>{label}</span>
    </button>
  );
}

